<template>
  <div>
    <div class="tile my-4 px-3 py-4">
      <flow-group :flow-group="flowGroup" />
    </div>
    <div class="tile my-4">
      <div class="ml-auto">
        <manual-link-button :manual-link="manualLink" />
      </div>
      <activity-log
        :additionalFilters="activityFilters"
        :integrationFlowId="integrationFlowId"
        :integrationId="integrationId"
        :isAdmin="isAdmin || isPartner"
        :userId="user.id"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardLayout from '@/Layouts/DashboardLayout';
import IntegrationFlowLayout from '@/Layouts/IntegrationFlowLayout';
import FlowGroup from '@/components/Dashboard/FlowGroup';
import ActivityLog from '@/components/Dashboard/ActivityLog';
import ManualLinkButton from '@/components/Shared/ManualLinkButton.vue';

export default {
  name: 'FlowActivity',

  layout: [DashboardLayout, IntegrationFlowLayout],

  components: {
    ManualLinkButton,
    ActivityLog,
    FlowGroup,
  },

  props: {
    user: Object,
    manualLink: String,
  },

  computed: {
    ...mapGetters('flowsDetails', ['getFlow', 'sendFlow', 'flowGroup', 'userIntegrationFlow', 'isAdmin', 'isPartner']),

    integrationId() {
      return this.$route().params.integration;
    },

    integrationFlowId() {
      return this.userIntegrationFlow.id;
    },

    activityFilters() {
      return { flowIds: [this.getFlow.id, this.sendFlow.id], userIntegrationFlowId: this.userIntegrationFlow.id };
    },
  },
};
</script>
